import React, { useState, useRef, useEffect } from 'react';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomCategorySelect = ({
  options,
  value,
  onChange,
  placeholder = "General",
  name,
  fullWidth = true,
  compactText = false
}) => {
  const textSize = compactText ? 'text-sm' : 'text-base';
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelectedValue(option);
    if (onChange) {
      onChange(option);
    }
    setIsOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`relative ${fullWidth ? 'w-full' : 'w-auto'}`}
    >
      <button
        type="button"
        className={`
          bg-white
          h-[45px]
          px-4
          rounded-lg
          border
          border-[#bdbdbd]
          hover:border-slate-900
          focus:border-violet-700
          focus:outline-none
          focus:ring-1
          focus:ring-violet-700
          flex
          items-center
          justify-between
          gap-2
          ${fullWidth ? 'w-full' : 'w-auto'}
        `}
        title={selectedValue || undefined}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`${textSize} min-w-0 truncate text-left ${!selectedValue ? 'text-[#9e9e9e]' : 'text-gray-900'}`}>
          {selectedValue || placeholder}
        </span>
        <div className="shrink-0 text-[#9e9e9e]">
          <ExpandMoreIcon
            className={`w-4 h-4 transition-transform ${isOpen ? 'transform rotate-180' : ''}`}
          />
        </div>
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200">
          {options.map((option, index) => (
            <button
              key={index}
              className={`w-full px-4 py-2.5 ${textSize} text-left hover:bg-violet-50 focus:bg-violet-50 focus:outline-none`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomCategorySelect;
